import $ from "jquery";
const productFilterSubCategory = () => {
  const target = {
    body: ".tax-product_cat",
    wpf: ".wpf_hierachy",
  };
  const $body = $(target.body);
  const $wpf = $(target.wpf);
  const init = () => {
    $(document).ready(function () {
      if ($body.length) {
        exec();
      }
    });
  };
  const exec = () => {
    const archiveEmpty = $body.find(".elementor-nothing-found");
    if (archiveEmpty.length) {
      $body.find(target.wpf).hide();
      return;
    }

    $wpf.find("input:checked").each(function () {
      const $this = $(this);
      $this.parent().find("li").show();
      $this.parent().find("ul").addClass("row");
      if ($this.parent().parent().attr("class") !== "wpf_hierachy") {
        $this.parent().siblings().addClass("row");
      }
      //   $this.parentsUntil("ul.wpf_submenu").children("li").addClass("row");
      $this.parentsUntil(".wpf_hierachy").addClass("row");
      $this.removeAttr("readonly");
    });
  };
  init();
};

try {
  productFilterSubCategory();
} catch (error) {
  throw new Error(error);
}
